import { render, staticRenderFns } from "./Pinxhistory.vue?vue&type=template&id=4b3617ff&scoped=true&"
import script from "./Pinxhistory.vue?vue&type=script&lang=js&"
export * from "./Pinxhistory.vue?vue&type=script&lang=js&"
import style0 from "./Pinxhistory.vue?vue&type=style&index=0&id=4b3617ff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3617ff",
  null
  
)

export default component.exports